import { EVENT_ACTIONS } from "../actions/actionTypes";

const initialState = {
    event: null,
    expertsList: [],
    previous_events: null,
    upcoming_events: null,
    isListLoading: false,
    isEventLoading: false,
};

export default function(state = initialState, action) {
  const { data } = action.payload || {};
  switch (action.type) {
    case EVENT_ACTIONS.EVENT_LIST_DATA._START:
      return  {
        ...state,
        previous_events: null,
        upcoming_events: null,
        isListLoading: true
      }
    case EVENT_ACTIONS.EVENT_LIST_DATA._SUCCESS:
      return {
        ...state,
        ...data
      };
    case EVENT_ACTIONS.EVENT_LIST_DATA._FAILURE:
      return initialState;
   
    case EVENT_ACTIONS.EVENT_DATA._START:
      return  {
        ...state,
        event: null,
        expertList: null,
        isEventLoading: true
      }
      
    case EVENT_ACTIONS.EVENT_DATA._SUCCESS:
      return {
        ...state,
        ...data
      };

    case EVENT_ACTIONS.EVENT_DATA._FAILURE:
      return initialState;

    default:
      return state;
  }
}
